export const setEscapeBuckAmount = (data) => {
    return {
        type: "ESCAPEBUCKAMOUNT",
        payload: data
    }
}
export const setEscapeBuckRedeemModal = (data) => {
    return {
        type: "ESCAPEBUCKCODEREDEEMMODAL",
        payload: data
    }
}
export const setApiCallForFetchingEscapeBuckAmount = (data) => {
    return {
        type: "ESCAPEBUCKAPICALLFETCHING",
        payload: data
    }
}
export const setApiCallForFetchingEscapeRedeemHistory = (data) => {
    return {
        type: "ESCAPEBUCKAPICALLFETCHINGFORREDEEMHISTORY",
        payload: data
    }
}

